var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 12.4615H9.33333V10.3846H8V12.4615H6V13.8462H8V15.9231H9.33333V13.8462H11.3333V12.4615ZM18 13.1538C19.1067 13.1538 19.9933 12.2262 19.9933 11.0769C19.9933 9.92769 19.1067 9 18 9C17.7867 9 17.58 9.03462 17.3933 9.09692C17.7733 9.65769 17.9933 10.3362 17.9933 11.0769C17.9933 11.8177 17.7667 12.4892 17.3933 13.0569C17.58 13.1192 17.7867 13.1538 18 13.1538ZM14.6667 13.1538C15.7733 13.1538 16.66 12.2262 16.66 11.0769C16.66 9.92769 15.7733 9 14.6667 9C13.56 9 12.6667 9.92769 12.6667 11.0769C12.6667 12.2262 13.56 13.1538 14.6667 13.1538ZM19.08 14.6492C19.6333 15.1546 20 15.7985 20 16.6154V18H22V16.6154C22 15.5492 20.42 14.8915 19.08 14.6492ZM14.6667 14.5385C13.3333 14.5385 10.6667 15.2308 10.6667 16.6154V18H18.6667V16.6154C18.6667 15.2308 16 14.5385 14.6667 14.5385Z",
    fill: "#E33AA9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    stroke: "#F0EEF2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewUser);
export default __webpack_public_path__ + "static/media/newUser.cae0ee5c7b342f95eb57cf84d2b77d80.svg";
export { ForwardRef as ReactComponent };